<template>
  <page-component style="position: relative">
    <template #content>
      <!-- بيانات العميل -->
      <!-- <v-sheet class="px-5 py-5"> -->
      <div class="">
        <!-- <span class="font-weight-bold" style="display: inline">
            التمويل المرن 2*1</span
          > -->
        <v-btn style="
              padding-bottom: 5px;
              padding-top: 2px;
              width: fit-content;
              background: #451646;
              border-radius: 6px;
              font-size: 12px;
              display: flex !important;
              align-items: center;
              position: absolute;
              top: -45px;
            " dark depressed router :to="{ name: 'FundHistory', params: { id: $route.params.id } }">
          <svg xmlns="http://www.w3.org/2000/svg" width="14.324" height="14.325" viewBox="0 0 14.324 14.325"
            style="margin-left: 6px; margin-bottom: -2px">
            <g id="history" transform="translate(-6.503 -6.5)">
              <path id="Path_3979" data-name="Path 3979"
                d="M13.665,20.825A7.163,7.163,0,0,1,8.946,8.275a.423.423,0,0,1,.562.632,6.32,6.32,0,1,0,4.157-1.565.421.421,0,1,1,0-.843,7.163,7.163,0,0,1,0,14.325Z"
                fill="#fff" />
              <path id="Path_3980" data-name="Path 3980"
                d="M15.292,15.2a.421.421,0,0,1-.419-.379L14.685,12.9a.423.423,0,1,1,.843-.081l.188,1.918a.424.424,0,0,1-.382.461Z"
                transform="translate(-5.882 -4.27)" fill="#fff" />
              <path id="Path_3981" data-name="Path 3981"
                d="M8.251,13.308a.421.421,0,0,1,0-.843l1.927-.025a.421.421,0,0,1,0,.843l-1.93.025Zm6.368,5.048a.421.421,0,0,1-.421-.421V13.822a.421.421,0,1,1,.843,0v4.112A.421.421,0,0,1,14.619,18.355Z"
                transform="translate(-0.954 -4.272)" fill="#fff" />
              <path id="Path_3982" data-name="Path 3982"
                d="M33.7,32.785a.438.438,0,0,1-.194-.048l-2.829-1.466a.421.421,0,1,1,.388-.747L33.9,31.988a.424.424,0,0,1-.194.8Z"
                transform="translate(-17.211 -17.235)" fill="#fff" />
            </g>
          </svg>

          سجل حاسبة التمويل
        </v-btn>
      </div>
      <v-form class="mt-10">
        <v-row>
          <v-col cols="12">
            <v-sheet class="px-5 py-5">
              <!-- form-data -->
              <v-row>
                <v-col cols="12" lg="3" md="4" sm="6" xs="12" class="mb-5 py-0">
                  <div class="mb-2 mr-2">
                    <img src="@/assets/icons/material-history.svg" alt="image" style="margin-top: 5px; margin-left: 5px"
                      @click="show_Field_log('birth_hijri')" />
                    تاريخ الميلاد (هجري)
                  </div>
                  <new-date-fields v-model="payload.birthDate" @update:miladi="payload.birthDateMiladi = $event"
                    :defaultHijri="agent.customer.birth_date_higri" />
                </v-col>
                <v-col cols="12" lg="3" md="4" sm="6" xs="12" class="mb-5 py-0">
                  <div class="mb-2 mr-2">تاريخ اليوم (هجري)</div>

                  <new-date-fields v-model="payload.currentDate" @update:miladi="payload.currentDateMiladi = $event"
                    :defaultHijri="todayHijri" />

                </v-col>
                <v-col cols="12" lg="3" md="4" sm="6" xs="12" class="mb-5 py-0">
                  <div class="mb-2 mr-2">
                    <img src="@/assets/icons/material-history.svg" alt="image" style="margin-top: 5px; margin-left: 5px"
                      @click="show_Field_log('hiring_date')" />
                    تاريخ التعيين
                  </div>
                  <new-date-fields v-model="payload.hiringDate" @update:miladi="payload.hiringDateMiladi = $event"
                    :defaultHijri="agent.customer.hiring_date" />

                </v-col>
                <v-col cols="12" lg="1" md="2" sm="3" xs="12" class="mb-5 py-0">
                  <div class="mb-2 mr-2">العمر</div>
                  <v-text-field hide-details v-model="payload.age" class="mr-1" outlined v-numericOnly
                    dense></v-text-field>
                </v-col>
                <v-col cols="12" lg="1" md="2" sm="3" xs="12" class="mb-5 py-0">
                  <div class="mb-2 mr-2">عمر التقاعد </div>
                  <v-text-field hide-details v-model="payload.retirment_age" class="mr-1" outlined v-numericOnly
                    dense></v-text-field>
                </v-col>
                <v-col cols="12" lg="1" md="2" sm="3" xs="12" class="mb-5 py-0">
                  <div class="mb-2 mr-2">العمر الاقصي </div>
                  <v-text-field hide-details v-model="payload.max_age" class="mr-1" outlined v-numericOnly
                    dense></v-text-field>
                </v-col>
                <v-col cols="12" lg="2" md="3" sm="6" xs="12" class="mb-5 py-0">
                  <div class="mb-2 mr-2">
                    <img src="@/assets/icons/material-history.svg" alt="image" style="margin-top: 5px; margin-left: 5px"
                      @click="show_Field_log('basic_salary')" />
                    الراتب الأساسي
                  </div>
                  <v-text-field hide-details v-model="payload.basicSalary" class="mr-1" outlined v-numericOnly
                    dense></v-text-field>
                </v-col>
                <v-col cols="12" lg="2" md="3" sm="6" xs="12" class="mb-5 py-0">
                  <div class="mb-2 mr-2">
                    <img src="@/assets/icons/material-history.svg" alt="image" style="margin-top: 5px; margin-left: 5px"
                      @click="show_Field_log('salary')" />
                    صافي الراتب
                  </div>
                  <v-text-field hide-details v-model="payload.salary" class="mr-1" outlined v-numericOnly
                    dense></v-text-field>
                </v-col>
                <v-col cols="12" lg="2" md="3" sm="6" xs="12" class="mb-5 py-0">
                  <div class="mb-2 mr-2">

                    <img src="@/assets/icons/material-history.svg" alt="image" style="margin-top: 5px; margin-left: 5px"
                      @click="show_Field_log('work')" />
                    جهة العمل
                  </div>
                  <v-autocomplete :items="jobs" hide-details v-model="payload.job_position" item-text="value"
                    item-value="id" class="mr-1" outlined dense append-icon>
                    <template v-slot:append>
                      <svg xmlns="http://www.w3.org/2000/svg" width="11.532" height="6.328" viewBox="0 0 11.532 6.328"
                        style="margin-top: 8px">
                        <path id="Icon_ionic-ios-arrow-down" data-name="Icon ionic-ios-arrow-down"
                          d="M11.956,15.667l4.361-4.188a.845.845,0,0,1,1.164,0,.775.775,0,0,1,0,1.12L12.54,17.344a.848.848,0,0,1-1.136.023L6.428,12.6a.773.773,0,0,1,0-1.12.845.845,0,0,1,1.164,0Z"
                          transform="translate(-6.188 -11.246)" fill="#6c757d" />
                      </svg>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" lg="2" md="3" sm="6" xs="12" class="mb-5 py-0" v-if="payload.job_position == '1'">
                  <div class="mb-2 mr-2">الرتبة العسكريه</div>
                  <v-autocomplete :items="$store.state.military_ranks" hide-details v-model="payload.military_rank"
                    item-text="value" item-value="id" class="mr-1" outlined dense append-icon>
                    <template v-slot:append>
                      <svg xmlns="http://www.w3.org/2000/svg" width="11.532" height="6.328" viewBox="0 0 11.532 6.328"
                        style="margin-top: 8px">
                        <path id="Icon_ionic-ios-arrow-down" data-name="Icon ionic-ios-arrow-down"
                          d="M11.956,15.667l4.361-4.188a.845.845,0,0,1,1.164,0,.775.775,0,0,1,0,1.12L12.54,17.344a.848.848,0,0,1-1.136.023L6.428,12.6a.773.773,0,0,1,0-1.12.845.845,0,0,1,1.164,0Z"
                          transform="translate(-6.188 -11.246)" fill="#6c757d" />
                      </svg>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" lg="2" md="3" sm="6" xs="12" class="mb-5 py-0">
                  <!-- <div class="mb-2 mr-2">جهة نزول المرتب</div> -->
                  <div class="mb-2 mr-2">جهة التمويل </div>
                  <v-autocomplete :items="banks" item-text="value" item-value="id" hide-details
                    v-model="payload.bank_id" class="mr-1" outlined dense append-icon>
                    <template v-slot:append>
                      <svg xmlns="http://www.w3.org/2000/svg" width="11.532" height="6.328" viewBox="0 0 11.532 6.328"
                        style="margin-top: 8px">
                        <path id="Icon_ionic-ios-arrow-down" data-name="Icon ionic-ios-arrow-down"
                          d="M11.956,15.667l4.361-4.188a.845.845,0,0,1,1.164,0,.775.775,0,0,1,0,1.12L12.54,17.344a.848.848,0,0,1-1.136.023L6.428,12.6a.773.773,0,0,1,0-1.12.845.845,0,0,1,1.164,0Z"
                          transform="translate(-6.188 -11.246)" fill="#6c757d" />
                      </svg> </template></v-autocomplete>
                </v-col>
                <!-- </v-row> -->
                <!-- <v-divider class="my-3"></v-divider> -->
                <!-- <v-row> -->

                <v-col cols="12" lg="2" md="3" sm="6" xs="12" class="mb-5 py-0">
                  <div class="mb-2 mr-2">نوع المنتج</div>
                  <v-autocomplete :items="$store.state.app_products" hide-details v-model="payload.product_code"
                    item-text="text" item-value="code" class="mr-1" outlined dense append-icon>
                    <template v-slot:append>
                      <svg xmlns="http://www.w3.org/2000/svg" width="11.532" height="6.328" viewBox="0 0 11.532 6.328"
                        style="margin-top: 8px">
                        <path id="Icon_ionic-ios-arrow-down" data-name="Icon ionic-ios-arrow-down"
                          d="M11.956,15.667l4.361-4.188a.845.845,0,0,1,1.164,0,.775.775,0,0,1,0,1.12L12.54,17.344a.848.848,0,0,1-1.136.023L6.428,12.6a.773.773,0,0,1,0-1.12.845.845,0,0,1,1.164,0Z"
                          transform="translate(-6.188 -11.246)" fill="#6c757d" />
                      </svg>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" lg="2" md="3" sm="6" xs="12">

                  <div class="mb-2 mr-2">قسط الدعم</div>
                  <v-text-field hide-details v-model="payload.support_amount" class="mr-1" type="number" outlined
                    dense></v-text-field>
                </v-col>
                <v-col cols="12" lg="2" md="3" sm="6" xs="12">
                  <div class="mb-2 mr-2" style="height:22px;"> </div>
                  <v-checkbox :true-value="1" :false-value="0" label="إضافة قسط إلي دعم الراتب"
                    v-model="payload.add_support_installment_to_salary" />
                </v-col>
                <v-col cols="12" lg="2" md="3" sm="6" xs="12">
                  <div class="mb-2 mr-2">تحمل الصندوق من الارباح </div>
                  <v-text-field hide-details class="mr-1" dense type="number" v-model="payload.box_amount" outlined />
                </v-col>
                <!-- </v-row> -->
                <!--<v-row>
            <v-col cols="12" lg="2" md="3" sm="6" xs="12">
              <v-switch
                :true-value="1"
                :false-value="0"
                inset
                flat
                label="الدعم السكني"
                v-model="payload.residential_support"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              lg="3"
              md="4"
              sm="6"
              xs="12"
              v-if="payload.residential_support"
            >
              <v-checkbox
                :true-value="1"
                :false-value="0"
                label="إضافة قسط إلي دعم الراتب"
                v-model="payload.add_support_installment_to_salary"
              />
            </v-col>
            <v-col
              cols="12"
              lg="3"
              md="4"
              sm="6"
              xs="12"
              v-if="payload.residential_support"
            >
              <v-checkbox
                :true-value="1"
                :false-value="0"
                label="الضمانات"
                v-model="payload.guarantees"
              />
            </v-col>
          </v-row> -->
                <!--<v-divider class="my-3"></v-divider>
          <v-row>
            <v-col cols="12" lg="2" md="3" sm="6" xs="12">
              <v-switch
                :true-value="1"
                :false-value="0"
                inset
                flat
                label="إظهار نسبة الإستقطاع"
                v-model="payload.deduction_percentage"
              />
            </v-col>
          </v-row>
          <v-row v-if="payload.deduction_percentage">
            <v-col cols="12" lg="2" md="3" sm="6" xs="12">
              <div class="mb-2 mr-2">نسبة استقطاع صافي الراتب(شخصي)</div>
              <v-text-field
                hide-details
                v-model="payload.personal_salary_deduction"
                class="mr-1"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" lg="2" md="3" sm="6" xs="12">
              <div class="mb-2 mr-2">مدة التمويل بالشهور (شخصي)</div>
              <v-text-field
                hide-details
                v-model="payload.personal_funding_months"
                class="mr-1"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" lg="2" md="3" sm="6" xs="12">
              <div class="mb-2 mr-2">نسبة الإستقطاع</div>
              <v-text-field
                hide-details
                v-model="payload.salary_deduction"
                class="mr-1"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" lg="2" md="3" sm="6" xs="12">
              <div class="mb-2 mr-2">مدة التمويل بالشهور</div>
              <v-text-field
                hide-details
                v-model="payload.funding_months"
                class="mr-1"
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>-->
                <!-- <v-divider class="my-3"></v-divider> -->
                <!-- <v-row> -->
                <v-col cols="12" lg="2" md="3" sm="6" xs="12">
                  <div class="mb-2 mr-2">قيمة العقار</div>
                  <v-text-field hide-details v-model="payload.property_amount" class="mr-1" outlined v-numericOnly
                    dense></v-text-field>
                </v-col>
                <v-col cols="12" lg="2" md="3" sm="6" xs="12">
                  <div class="mb-2 mr-2">حالة العقار</div>
                  <v-autocomplete :items="[
                    { text: 'عقار مكتمل', value: 1 },
                    { text: 'عقار غير مكتمل', value: 0 },
                  ]" hide-details v-model="payload.property_completed" item-text="text" item-value="value" class="mr-1"
                    outlined dense append-icon>
                    <template v-slot:append>
                      <svg xmlns="http://www.w3.org/2000/svg" width="11.532" height="6.328" viewBox="0 0 11.532 6.328"
                        style="margin-top: 8px">
                        <path id="Icon_ionic-ios-arrow-down" data-name="Icon ionic-ios-arrow-down"
                          d="M11.956,15.667l4.361-4.188a.845.845,0,0,1,1.164,0,.775.775,0,0,1,0,1.12L12.54,17.344a.848.848,0,0,1-1.136.023L6.428,12.6a.773.773,0,0,1,0-1.12.845.845,0,0,1,1.164,0Z"
                          transform="translate(-6.188 -11.246)" fill="#6c757d" />
                      </svg> </template></v-autocomplete>
                </v-col>
                <v-col cols="12" lg="2" md="3" sm="6" xs="12">
                  <div class="mb-2 mr-2">المسكن</div>
                  <v-autocomplete :items="[
                    { text: 'مسكن أول', value: 1 },
                    { text: 'مسكن ثاني', value: 2 },
                  ]" hide-details v-model="payload.residence_type" item-text="text" item-value="value" class="mr-1"
                    outlined dense append-icon>
                    <template v-slot:append>
                      <svg xmlns="http://www.w3.org/2000/svg" width="11.532" height="6.328" viewBox="0 0 11.532 6.328"
                        style="margin-top: 8px">
                        <path id="Icon_ionic-ios-arrow-down" data-name="Icon ionic-ios-arrow-down"
                          d="M11.956,15.667l4.361-4.188a.845.845,0,0,1,1.164,0,.775.775,0,0,1,0,1.12L12.54,17.344a.848.848,0,0,1-1.136.023L6.428,12.6a.773.773,0,0,1,0-1.12.845.845,0,0,1,1.164,0Z"
                          transform="translate(-6.188 -11.246)" fill="#6c757d" />
                      </svg> </template></v-autocomplete>
                </v-col>
                <v-col cols="12" lg="2" md="3" sm="6" xs="12">
                  <div class="mb-2 mr-2">نوع التاريخ المستخدم</div>
                  <v-autocomplete :items="[
                    { text: 'هجري', value: 1 },
                    { text: 'ميلادي', value: 2 },
                  ]" hide-details v-model="payload.date_type" item-text="text" item-value="value" class="mr-1"
                    outlined dense append-icon>
                    <template v-slot:append>
                      <svg xmlns="http://www.w3.org/2000/svg" width="11.532" height="6.328" viewBox="0 0 11.532 6.328"
                        style="margin-top: 8px">
                        <path id="Icon_ionic-ios-arrow-down" data-name="Icon ionic-ios-arrow-down"
                          d="M11.956,15.667l4.361-4.188a.845.845,0,0,1,1.164,0,.775.775,0,0,1,0,1.12L12.54,17.344a.848.848,0,0,1-1.136.023L6.428,12.6a.773.773,0,0,1,0-1.12.845.845,0,0,1,1.164,0Z"
                          transform="translate(-6.188 -11.246)" fill="#6c757d" />
                      </svg> </template></v-autocomplete>
                </v-col>
              </v-row>
              <v-divider class="my-3"></v-divider>
              <v-row>
                <v-col cols="12" lg="3" md="4" sm="6" xs="12">
                  <v-switch :true-value="1" :false-value="0" inset flat label="الإلتزامات"
                    v-model="payload.hasObligations" />
                </v-col>
              </v-row>
              <v-row v-if="payload.hasObligations">
                <v-col cols="12" lg="3" md="4" sm="6" xs="12">
                  <div class="mb-2 mr-2">قسط الإلتزامات</div>
                  <v-text-field hide-details v-model="payload.obligations_installment" class="mr-1" type="number"
                    outlined dense></v-text-field>
                    <!-- 
                    <v-text-field
                    hide-details
                    :value="payload.obligations_installment"
                    class="mr-1"
                    type="number"
                    outlined
                    dense
                    readonly
                  ></v-text-field>
                     -->
                </v-col>
                <v-col cols="12" lg="3" md="4" sm="6" xs="12">
                  <div class="mb-2 mr-2">أشهر الإلتزامات المتبقية</div>
                  <v-text-field hide-details v-model="payload.remaining_obligations_months" class="mr-1" type="number"
                    outlined dense></v-text-field>
                    <!-- 
                    <v-text-field
                    hide-details
                    :value="payload.remaining_obligations_months"
                    class="mr-1"
                    type="number"
                    outlined
                    dense
                    readonly
                  ></v-text-field>
                    -->
                </v-col>
                <v-col cols="12" lg="3" md="4" sm="6" xs="12">
                  <div class="mb-2 mr-2">قسط بنك التسليف</div>
                  <v-text-field hide-details v-model="payload.funding_source" class="mr-1" outlined
                    dense></v-text-field>
                </v-col>
                <v-col cols="12" lg="3" md="4" sm="6" xs="12">
                  <div class="mb-2 mr-2">مبلغ السداد المبكر</div>
                  <v-text-field hide-details v-model="payload.early_repayment" class="mr-1" outlined
                    dense></v-text-field>
                </v-col>
                <v-col cols="12">
                  <ObligationsTable v-model="obligations" />
                </v-col>
              </v-row>
              <v-divider class="my-3"></v-divider>

            </v-sheet>
            <!-- form-data -->
          </v-col>
          <!-- new reslut -->
          <!-- new reslut -->
          <v-col cols="12">

            <div>
              <v-sheet class="px-5 py_-5">
                <v-row>
                  <v-col cols="1" v-for="item in all_banks" :key="item.id" style="text-align: center;">
                    <div v-if="item.id == payload.bank_id"
                      :class="item.id == payload.bank_id ? 'selected-bank-div' : ''">
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-avatar v-bind="attrs"
                            style=" border: 2px solid #451646; text-align: center; font-size: 14px; padding: 5px; "
                            v-on="on" size="64" class="ma-2">
                            <v-img :src="item.image" :alt="item.title"></v-img>
                          </v-avatar>
                        </template>
                        <span>{{ item.title }}</span>
                      </v-tooltip>
                      <!-- {{ item.title }} <br/> -->
                      {{ item.finance_amount }}

                    </div>
                    <div v-else @click="recalculate(item.id)">
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-avatar v-bind="attrs"
                            style=" border: 1px solid #cecece; text-align: center; font-size: 14px; padding: 5px; "
                            v-on="on" size="64" class="ma-2">
                            <v-img :src="item.image" :alt="item.title"></v-img>
                          </v-avatar>
                        </template>
                        <span>{{ item.title }}</span>
                      </v-tooltip>
                      <!-- {{ item.title }} <br/> -->
                      {{ item.finance_amount }}

                    </div>
                  </v-col>

                </v-row>
              </v-sheet>
            </div>
            <v-sheet class="px-5 py_-5">
              <div v-if="all_banks.length == 0" class="svg-sec" style=" text-align: center; padding: 10px; ">
                <svg width="126" height="132" viewBox="0 0 126 132" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <foreignObject x="0" y="0.5" width="126" height="131">
                    <div xmlns="http://www.w3.org/1999/xhtml"
                      style="backdrop-filter:blur(2px);clip-path:url(#bgblur_0_1213_215_clip_path);height:100%;width:100%">
                    </div>
                  </foreignObject>
                  <g filter="url(#filter0_di_1213_215)" data-figma-bg-blur-radius="4">
                    <path
                      d="M5 36.5C5 19.3792 18.8792 5.5 36 5.5H90C107.121 5.5 121 19.3792 121 36.5V95.5C121 112.621 107.121 126.5 90 126.5H36C18.8792 126.5 5 112.621 5 95.5V36.5Z"
                      fill="url(#paint0_linear_1213_215)" fill-opacity="0.7" shape-rendering="crispEdges" />
                  </g>
                  <path d="M121 66.0024V101.5C121 106.913 101.793 126.5 96.5 126.5H62.9957V66.0024H121Z"
                    fill="url(#paint1_linear_1213_215)" />
                  <path d="M63.7472 5.5H62.2519V126.491H63.7472V5.5Z" fill="#451547" />
                  <path d="M120.999 65.2416H5V66.7688H120.999V65.2416Z" fill="#451547" />
                  <foreignObject x="81.4114" y="87.1853" width="25.271" height="19.4711">
                    <div xmlns="http://www.w3.org/1999/xhtml"
                      style="backdrop-filter:blur(2px);clip-path:url(#bgblur_1_1213_215_clip_path);height:100%;width:100%">
                    </div>
                  </foreignObject>
                  <path data-figma-bg-blur-radius="4"
                    d="M85.4114 99.3545V102.656H102.682V99.3545H85.4114ZM85.4114 91.1853V94.5064H102.682V91.1853H85.4114Z"
                    fill="white" />
                  <foreignObject x="21" y="21.5" width="30.0977" height="29.8577">
                    <div xmlns="http://www.w3.org/1999/xhtml"
                      style="backdrop-filter:blur(2px);clip-path:url(#bgblur_2_1213_215_clip_path);height:100%;width:100%">
                    </div>
                  </foreignObject>
                  <g filter="url(#filter2_di_1213_215)" data-figma-bg-blur-radius="4">
                    <path
                      d="M39.5588 34.0252C39.0065 34.0252 38.5588 33.5774 38.5588 33.0252V27.5C38.5588 26.9477 38.111 26.5 37.5588 26.5H34.5383C33.986 26.5 33.5383 26.9477 33.5383 27.5V33.0252C33.5383 33.5774 33.0906 34.0252 32.5383 34.0252H27C26.4477 34.0252 26 34.4729 26 35.0252V37.7704C26 38.3227 26.4477 38.7704 27 38.7704H32.5383C33.0906 38.7704 33.5383 39.2181 33.5383 39.7704V45.3577C33.5383 45.91 33.986 46.3577 34.5383 46.3577H37.5588C38.111 46.3577 38.5588 45.91 38.5588 45.3577V39.7704C38.5588 39.2181 39.0065 38.7704 39.5588 38.7704H45.0977C45.65 38.7704 46.0977 38.3227 46.0977 37.7704V35.0252C46.0977 34.4729 45.65 34.0252 45.0977 34.0252H39.5588Z"
                      fill="url(#paint2_linear_1213_215)" shape-rendering="crispEdges" />
                  </g>
                  <foreignObject x="81.4362" y="28.8618" width="25.2203" height="15.1335">
                    <div xmlns="http://www.w3.org/1999/xhtml"
                      style="backdrop-filter:blur(2px);clip-path:url(#bgblur_3_1213_215_clip_path);height:100%;width:100%">
                    </div>
                  </foreignObject>
                  <g filter="url(#filter3_di_1213_215)" data-figma-bg-blur-radius="4">
                    <path
                      d="M100.656 33.8618H87.4362C86.8839 33.8618 86.4362 34.3095 86.4362 34.8618V37.9953C86.4362 38.5476 86.8839 38.9953 87.4362 38.9953H100.656C101.209 38.9953 101.656 38.5476 101.656 37.9953V34.8618C101.656 34.3095 101.209 33.8618 100.656 33.8618Z"
                      fill="url(#paint3_linear_1213_215)" shape-rendering="crispEdges" />
                  </g>
                  <foreignObject x="22.5035" y="83.492" width="27.0909" height="26.8682">
                    <div xmlns="http://www.w3.org/1999/xhtml"
                      style="backdrop-filter:blur(2px);clip-path:url(#bgblur_4_1213_215_clip_path);height:100%;width:100%">
                    </div>
                  </foreignObject>
                  <g filter="url(#filter4_di_1213_215)" data-figma-bg-blur-radius="4">
                    <path
                      d="M44.2962 91.8507C44.6938 91.459 44.6937 90.8177 44.2961 90.426L42.6248 88.7796C42.2355 88.3961 41.6104 88.3962 41.2211 88.7797L36.7503 93.1848C36.361 93.5684 35.7359 93.5684 35.3466 93.1848L30.8766 88.7798C30.4874 88.3962 29.8623 88.3962 29.473 88.7797L27.8018 90.426C27.4042 90.8177 27.4041 91.459 27.8017 91.8507L32.2294 96.2139C32.6269 96.6056 32.6269 97.2468 32.2293 97.6385L27.8017 102C27.4041 102.392 27.4041 103.033 27.8015 103.425L29.473 105.072C29.8623 105.456 30.4875 105.456 30.8768 105.072L35.3466 100.668C35.7359 100.284 36.361 100.284 36.7503 100.668L41.221 105.073C41.6103 105.456 42.2355 105.456 42.6247 105.073L44.2964 103.425C44.6939 103.033 44.6938 102.392 44.2962 102L39.8679 97.6386C39.4703 97.2469 39.4703 96.6055 39.8679 96.2138L44.2962 91.8507Z"
                      fill="url(#paint4_linear_1213_215)" shape-rendering="crispEdges" />
                  </g>
                  <defs>
                    <filter id="filter0_di_1213_215" x="0" y="0.5" width="126" height="131" filterUnits="userSpaceOnUse"
                      color-interpolation-filters="sRGB">
                      <feFlood flood-opacity="0" result="BackgroundImageFix" />
                      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha" />
                      <feOffset />
                      <feGaussianBlur stdDeviation="2.5" />
                      <feComposite in2="hardAlpha" operator="out" />
                      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                      <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1213_215" />
                      <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1213_215" result="shape" />
                      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha" />
                      <feOffset dy="-1" />
                      <feGaussianBlur stdDeviation="2" />
                      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                      <feBlend mode="normal" in2="shape" result="effect2_innerShadow_1213_215" />
                    </filter>
                    <clipPath id="bgblur_0_1213_215_clip_path" transform="translate(0 -0.5)">
                      <path
                        d="M5 36.5C5 19.3792 18.8792 5.5 36 5.5H90C107.121 5.5 121 19.3792 121 36.5V95.5C121 112.621 107.121 126.5 90 126.5H36C18.8792 126.5 5 112.621 5 95.5V36.5Z" />
                    </clipPath>
                    <clipPath id="bgblur_1_1213_215_clip_path" transform="translate(-81.4114 -87.1853)">
                      <path
                        d="M85.4114 99.3545V102.656H102.682V99.3545H85.4114ZM85.4114 91.1853V94.5064H102.682V91.1853H85.4114Z" />
                    </clipPath>
                    <filter id="filter2_di_1213_215" x="21" y="21.5" width="30.0977" height="29.8577"
                      filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                      <feFlood flood-opacity="0" result="BackgroundImageFix" />
                      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha" />
                      <feOffset />
                      <feGaussianBlur stdDeviation="2.5" />
                      <feComposite in2="hardAlpha" operator="out" />
                      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                      <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1213_215" />
                      <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1213_215" result="shape" />
                      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha" />
                      <feOffset dy="-1" />
                      <feGaussianBlur stdDeviation="2" />
                      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                      <feBlend mode="normal" in2="shape" result="effect2_innerShadow_1213_215" />
                    </filter>
                    <clipPath id="bgblur_2_1213_215_clip_path" transform="translate(-21 -21.5)">
                      <path
                        d="M39.5588 34.0252C39.0065 34.0252 38.5588 33.5774 38.5588 33.0252V27.5C38.5588 26.9477 38.111 26.5 37.5588 26.5H34.5383C33.986 26.5 33.5383 26.9477 33.5383 27.5V33.0252C33.5383 33.5774 33.0906 34.0252 32.5383 34.0252H27C26.4477 34.0252 26 34.4729 26 35.0252V37.7704C26 38.3227 26.4477 38.7704 27 38.7704H32.5383C33.0906 38.7704 33.5383 39.2181 33.5383 39.7704V45.3577C33.5383 45.91 33.986 46.3577 34.5383 46.3577H37.5588C38.111 46.3577 38.5588 45.91 38.5588 45.3577V39.7704C38.5588 39.2181 39.0065 38.7704 39.5588 38.7704H45.0977C45.65 38.7704 46.0977 38.3227 46.0977 37.7704V35.0252C46.0977 34.4729 45.65 34.0252 45.0977 34.0252H39.5588Z" />
                    </clipPath>
                    <filter id="filter3_di_1213_215" x="81.4362" y="28.8618" width="25.2203" height="15.1335"
                      filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                      <feFlood flood-opacity="0" result="BackgroundImageFix" />
                      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha" />
                      <feOffset />
                      <feGaussianBlur stdDeviation="2.5" />
                      <feComposite in2="hardAlpha" operator="out" />
                      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                      <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1213_215" />
                      <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1213_215" result="shape" />
                      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha" />
                      <feOffset dy="-1" />
                      <feGaussianBlur stdDeviation="2" />
                      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                      <feBlend mode="normal" in2="shape" result="effect2_innerShadow_1213_215" />
                    </filter>
                    <clipPath id="bgblur_3_1213_215_clip_path" transform="translate(-81.4362 -28.8618)">
                      <path
                        d="M100.656 33.8618H87.4362C86.8839 33.8618 86.4362 34.3095 86.4362 34.8618V37.9953C86.4362 38.5476 86.8839 38.9953 87.4362 38.9953H100.656C101.209 38.9953 101.656 38.5476 101.656 37.9953V34.8618C101.656 34.3095 101.209 33.8618 100.656 33.8618Z" />
                    </clipPath>
                    <filter id="filter4_di_1213_215" x="22.5035" y="83.492" width="27.0909" height="26.8682"
                      filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                      <feFlood flood-opacity="0" result="BackgroundImageFix" />
                      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha" />
                      <feOffset />
                      <feGaussianBlur stdDeviation="2.5" />
                      <feComposite in2="hardAlpha" operator="out" />
                      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                      <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1213_215" />
                      <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1213_215" result="shape" />
                      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha" />
                      <feOffset dy="-1" />
                      <feGaussianBlur stdDeviation="2" />
                      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                      <feBlend mode="normal" in2="shape" result="effect2_innerShadow_1213_215" />
                    </filter>
                    <clipPath id="bgblur_4_1213_215_clip_path" transform="translate(-22.5035 -83.492)">
                      <path
                        d="M44.2962 91.8507C44.6938 91.459 44.6937 90.8177 44.2961 90.426L42.6248 88.7796C42.2355 88.3961 41.6104 88.3962 41.2211 88.7797L36.7503 93.1848C36.361 93.5684 35.7359 93.5684 35.3466 93.1848L30.8766 88.7798C30.4874 88.3962 29.8623 88.3962 29.473 88.7797L27.8018 90.426C27.4042 90.8177 27.4041 91.459 27.8017 91.8507L32.2294 96.2139C32.6269 96.6056 32.6269 97.2468 32.2293 97.6385L27.8017 102C27.4041 102.392 27.4041 103.033 27.8015 103.425L29.473 105.072C29.8623 105.456 30.4875 105.456 30.8768 105.072L35.3466 100.668C35.7359 100.284 36.361 100.284 36.7503 100.668L41.221 105.073C41.6103 105.456 42.2355 105.456 42.6247 105.073L44.2964 103.425C44.6939 103.033 44.6938 102.392 44.2962 102L39.8679 97.6386C39.4703 97.2469 39.4703 96.6055 39.8679 96.2138L44.2962 91.8507Z" />
                    </clipPath>
                    <linearGradient id="paint0_linear_1213_215" x1="121" y1="-87.1509" x2="-273.657" y2="469.223"
                      gradientUnits="userSpaceOnUse">
                      <stop stop-color="white" />
                      <stop offset="1" stop-color="#0E807F" />
                    </linearGradient>
                    <linearGradient id="paint1_linear_1213_215" x1="4.99156" y1="96.2512" x2="121" y2="96.2512"
                      gradientUnits="userSpaceOnUse">
                      <stop offset="0.0338" stop-color="#9747FF" />
                      <stop offset="1" stop-color="#9747FF" stop-opacity="0" />
                    </linearGradient>
                    <linearGradient id="paint2_linear_1213_215" x1="11.4867" y1="21.4591" x2="61.4867" y2="61.4591"
                      gradientUnits="userSpaceOnUse">
                      <stop stop-color="#9747FF" />
                      <stop offset="1" stop-color="#9747FF" stop-opacity="0" />
                    </linearGradient>
                    <linearGradient id="paint3_linear_1213_215" x1="86.4867" y1="27.4591" x2="98.9866" y2="43.9591"
                      gradientUnits="userSpaceOnUse">
                      <stop stop-color="#9747FF" />
                      <stop offset="1" stop-color="#9747FF" stop-opacity="0" />
                    </linearGradient>
                    <linearGradient id="paint4_linear_1213_215" x1="22.4867" y1="88.4591" x2="45.4867" y2="114.959"
                      gradientUnits="userSpaceOnUse">
                      <stop stop-color="#9747FF" />
                      <stop offset="1" stop-color="#9747FF" stop-opacity="0" />
                    </linearGradient>
                  </defs>
                </svg>

              </div>
              <div class="btn-sec" style=" text-align: center; padding: 10px; ">

                <v-alert dense text outlined type="error" class="mx-3" dismissible v-if="calc_error.length > 0">
                  <p v-for="(err, i) in calc_error" :key="i" style="text-align: right;">{{ err }}</p>
                </v-alert>
                <v-btn :loading="btn_loading" color="primary" width="255" @click="calculate">احسب</v-btn>
              </div>
              <div>
                <v-row style="direction: rtl;">

                  <v-divider class="my-3"></v-divider>
                  
              <v-row style="width: 100%;" v-if="showFactors" ref="defaultSec">
                <v-col cols="12">
                  <h5 class="mt-1 mb-1">القيم الافتراضية</h5>

                </v-col>
                <v-col cols="2">
                  <div class="default-val-div"
                    :style="{ border: Number(payload.before_retirment_deduction) <= 0 ? '2px solid red' : '' }">

                    <div class="mb-2 mr-2">الاستقطاع الأول (0.00)</div>
                    <v-text-field v-model="payload.before_retirment_deduction" type="number" hide-details class="mr-1"
                      outlined dense />
                  </div>
                </v-col>
                <v-col cols="2">
                  <div class="default-val-div"
                    :style="{ border: Number(payload.personal_deduction) <= 0 ? '2px solid red' : '' }">

                    <div class="mb-2 mr-2">الاستقطاع الشخصي (0.00)</div>
                    <v-text-field v-model="payload.personal_deduction" type="number" hide-details class="mr-1" outlined
                      dense />
                  </div>
                </v-col>
                <v-col cols="2">
                  <div class="default-val-div"
                    :style="{ border: Number(payload.profit_personal) <= 0 ? '2px solid red' : '' }">

                    <div class="mb-2 mr-2">هامش الربح الشخصي </div>
                    <v-text-field v-model="payload.profit_personal" type="number" hide-details class="mr-1" outlined
                      dense />
                  </div>
                </v-col>
                <v-col cols="2">
                  <div class="default-val-div"
                    :style="{ border: Number(payload.after_retirment_deduction) <= 0 ? '2px solid red' : '' }">

                    <div class="mb-2 mr-2">الاستقطاع الثاني (0.00)</div>
                    <v-text-field v-model="payload.after_retirment_deduction" type="number" hide-details class="mr-1"
                      outlined dense />
                  </div>
                </v-col>
                <v-col cols="2">
                  <div class="default-val-div" :style="{ border: Number(payload.profit) <= 0 ? '2px solid red' : '' }">

                    <div class="mb-2 mr-2">هامش الربح</div>
                    <v-text-field v-model="payload.profit" type="number" hide-details class="mr-1" outlined dense />
                  </div>
                </v-col>
                <v-col cols="2">
                  <div class="default-val-div"
                    :style="{ border: Number(payload.finance_duration) <= 0 ? '2px solid red' : '' }">

                    <div class="mb-2 mr-2"> مدة التمويل (سنة)</div>
                    <v-text-field v-model="payload.finance_duration" type="number" hide-details class="mr-1" outlined
                      dense />
                  </div>
                </v-col>
                <v-col cols="2" v-if="payload.job_position == 3">
                  <div class="default-val-div" :style="{ border: Number(payload.age_limit) <= 0 ? '2px solid red' : '' }">

                    <div class="mb-2 mr-2"> التمويل الي عمر </div>
                    <v-text-field v-model="payload.age_limit" type="number" hide-details class="mr-1" outlined dense />
                  </div>
                </v-col>
              </v-row>
                  <v-col cols="12" lg="3" md="3" sm="6" xs="12" v-for="(step, index) in result_v2_steps" :key="index">
                    <div
                      style="box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12); padding: 10px;">
                      <h4 style="color: #797b7e; padding-bottom:10px">
                        {{ step.title }}
                      </h4>
                      <div>
                        <v-row>
                          <v-col v-for="(item, idx) in step.data" :key="idx" :cols="item.cols || 12">
                            <div :style="{ border: '1px solid #451646', padding: '5px', color: '#7a747a', }">
                              {{ item.title }}: <span
                                :style="{ fontWeight: item.bold ? 'bold' : 'normal', color: '#451646' }">{{
                                item.value }}</span>
                            </div>
                          </v-col>
                        </v-row>
                      </div>
                    </div>

                  </v-col>
                  <v-col cols="12" style="text-align: center;" v-if="result.length > 0">
                    <v-btn @click="saveResultDialog" class="font-weight-bold" depressed color="#451646"
                      :loading="btn_save_loading" dark>
                      احفظ النتيجة
                    </v-btn>
                  </v-col>
                </v-row>
              </div>
            </v-sheet>
          </v-col>
        </v-row>
      </v-form>
      <!-- </v-sheet> -->

    </template>
  </page-component>
</template>

<script>
import moment from 'moment-hijri';
import Axios from "axios";
import ObligationsTable from "@/components/common/ObligationsTable.vue";
export default {
  props: ["agent"],
  components: { ObligationsTable },
  data() {
    return {
      expandedPanels: [],
      result_v2_steps: [],
      save_result_dialog: false,
      todayHijri: '',
      calc_error: [],
      jobs: [],
      banks: [],
      showFactors: false,
      choose_loading: false,
      btn_loading: false,
      btn_save_loading: false,
      show_date: false,
      show_date_2: false,
      show_date_2_1: false,
      obligations: [],
      payload: {
        hasObligations: this.agent.customer.has_obligations === 'yes' ? 1 : 0,
        before_retirment_deduction: null,
        after_retirment_deduction: null,
        profit_personal: null,
        profit: null,
        retirment_age: 60,
        personal_deduction: 0.33,
        finance_duration: 30,
        // profit_personal: null,
        bank_id: this.agent.funding.funding_source,
        product_code: null,
        job_position: null,
        work_source: null,
        military_rank: undefined,
        salary: null,
        birth_date_hijri: null,
        basic_salary: null,
        basicSalary: null,
        salary_source: null,
        hiring_date: null,
        residential_support: null,
        add_support_installment_to_salary: 0,
        guarantees: 0,
        personal_salary_deduction: null,
        personal_funding_months: null,
        deduction_percentage: 0,
        salary_deduction: null,
        funding_months: null,
        property_amount: null,
        property_completed: null,
        residence_type: null,
        date_type: 1,
        max_age: 70,
        has_obligations: this.agent.customer.has_obligations === 'yes' ? 1 : 0,
        remaining_obligations_months: this.agent.customer.remaining_obligations_months,
        obligations_installment: this.agent.customer.obligations_installment,
        early_repayment: null,
        funding_source: null,
        has_joint: 0,
        joint_work: null,
        joint_military_rank: null,
        joint_birth_hijri: undefined,
        joint_salary: null,
        joint_has_obligations: 0,
        joint_credit_installment: null,
        discount: null,
        provide_first_batch: 0,
        first_batch_profit: null,
        first_batch_percentage: null,
        fees: null,
        sahal: 0,
        housing_allowance: null,
        transfer_allowance: null,
        other_allowance: null,
        retirement_income: null,
        joint_remaining_obligations_months: null,
        joint_obligations_installment: null,
        joint_early_repayment: null,
        joint_housing_allowance: null,
        joint_transfer_allowance: null,
        joint_other_allowance: null,
        joint_retirement_income: null,
        joint_residential_support: null,
        joint_add_support_installment_to_salary: 0,
        joint_job_tenure_months: null,
        joint_personal_salary_deduction: null,
        joint_personal_funding_months: null,
        joint_funding_months: null,
        joint_salary_deduction: null,
        first_batch_mode: null,
        joint_job_tenure: null,
        joint_salary_source: null,
      },
      fundResult: [],
      GHResult: [],
      result: [],
      all_banks: [],
      showBanks: false,
      showGHBanks: false,
      newAgentData: {},
      savedResultPayload: {
        product_type: null,
        fundPersPre: null,
        fundMonth: null, //  القسط الشهري العقاري 
        fundDur: null,
        realFun_pre: null, // فائده التمويل العقاري
        funding_source: null, // جهة التمويل
        fundReal: null, // مبلغ التمويل العقاري 
        installment_after_support: null
      },
    };
  },
  async created() {
    this.newAgentData = { ...this.agent };
    this.payload.job_position = parseInt(this.newAgentData.customer.work_id);
    this.payload.salary = this.newAgentData.customer.salary;
    this.payload.basicSalary = this.newAgentData.customer.basic_salary;
    console.log("this.$store.state.request_info", this.$store.state.request_info)
    this.todayHijri = moment().format('iYYYY-iMM-iDD');
    this.initObligations();
    this.fetchBanks();
    this.fetchOptions();
    await this.setBreadCrumbs(["الرئيسية", "الطلبات", this.agent.customer.name]);
  },
  watch: {
    "payload.hasObligations": {
      handler(val) {
        const on = val ? 1 : 0;
        this.payload.has_obligations = on;
        if (on) {
          if (this.obligations.length === 0) {
            this.obligations = [
              { id: null, obligation_type_id: null, installment: 0, remaining_amount: 0 },
            ];
          }
        } else {
          this.obligations = [];
          this.payload.obligations_installment = null;
          this.payload.remaining_obligations_months = null;
        }
      },
      immediate: true,
    },
    obligations: {
      handler(val) {
        const rows = Array.isArray(val) ? val : [];
        const installmentSum = rows.reduce((sum, row) => {
          return sum + (parseFloat(row && row.installment) || 0);
        }, 0);

        // Approximate remaining months as the max months among obligations: ceil(remaining_amount / installment)
        const maxMonths = rows.reduce((max, row) => {
          const inst = parseFloat(row && row.installment) || 0;
          const remaining = parseFloat(row && row.remaining_amount) || 0;
          if (inst <= 0 || remaining <= 0) return max;
          return Math.max(max, Math.ceil(remaining / inst));
        }, 0);

        // this.payload.obligations_installment = installmentSum || 0;
        // this.payload.remaining_obligations_months = maxMonths || 0;

        // Keep request_info in sync for other screens / save payload merging
        if (this.$store.state.request_info) {
          this.$set(this.$store.state.request_info, "obligations", rows);
        }
      },
      deep: true,
    },
    "payload.bank_id"(val) {
      this.calculateFactors();
    },
    "payload.birthDate": {
      handler(val) {
        this.newAgentData.customer.birth_date_higri = val;
        this.$store.state.request_info = this.newAgentData;
        // this.$store.state.request_info.cutomer.birth_date_higri = val;
        this.calculateAgeFromHijri(val);
        this.calculateFactors();
      },
      deep: true,
    },
    "payload.currentDate"(val) {
      this.calculateFactors();
    },
    "payload.hiringDate": {
      handler(val) {

        this.newAgentData.customer.hiring_date = val;
        this.$store.state.request_info = this.newAgentData;
        // this.$store.state.request_info.cutomer.hiring_date = val;
        this.calculateFactors();
      },
      deep: true
    },
    "payload.remaining_obligations_months": {
      handler(val) {

        this.newAgentData.customer.remaining_obligations_months = val;
        this.$store.state.request_info = this.newAgentData;
      },
      deep: true
    },
    "payload.obligations_installment": {
      handler(val) {
        this.newAgentData.customer.obligations_installment = val;
        this.$store.state.request_info = this.newAgentData;
      },
      deep: true
    },
    "payload.retirment_age"(val) {
      this.calculateFactors();
    },
    "payload.job_position"(val) {
      this.newAgentData.customer.work = val;
      this.$store.state.request_info = this.newAgentData;
      this.calculateFactors();
    },
    "payload.salary": {
      handler(val) {
        this.newAgentData.customer.salary = val;
        this.$store.state.request_info = this.newAgentData;
        this.calculateFactors();
      },
      deep: true
    },
    "payload.basicSalary": {
      handler(val) {
        this.newAgentData.customer.basic_salary = val;
        this.$store.state.request_info = this.newAgentData;
        console.log("this.$store.state.request_info", this.$store.state.request_info)
      },
      deep: true
    },
  },
  methods: {
    initObligations() {
      const fromAgent = this.agent && Array.isArray(this.agent.obligations) ? this.agent.obligations : null;
      const fromStore =
        this.$store.state.request_info && Array.isArray(this.$store.state.request_info.obligations)
          ? this.$store.state.request_info.obligations
          : null;

      const src = (fromStore && fromStore.length ? fromStore : fromAgent) || [];
      this.obligations = src.map((item) => ({
        id: item.id ?? null,
        obligation_type_id: item.obligation_type_id ?? null,
        installment: parseFloat(item.installment) || 0,
        remaining_amount: parseFloat(item.remaining_amount) || 0,
      }));
    },
    getArabicErrorMessage(field) {
      const messages = {
        bank_id: 'جهة التمويل مطلوب',
        birthDate: 'تاريخ الميلاد مطلوب',
        retirement_age: 'عمر التقاعد مطلوب',
        hiringDate: 'تاريخ التعيين مطلوب',
        currentDate: 'التاريخ الحالي مطلوب',
        basicSalary: 'المرتب الأساسي مطلوب',
        salary: 'صافي الراتب مطلوب',
        job_position: 'جهة العمل مطلوب',
        product_code: 'نوع المنتج مطلوب',
      };

      return messages[field] || 'هذا الحقل مطلوب';
    },
    checkEachField(payload) {
      let $ar = [];
      if (payload.job_position != null && payload.job_position) {
        if (payload.job_position == 3) {
          $ar = [
            'bank_id',
            'birthDate',
            // 'retirement_age',
            // 'hiringDate',
            'currentDate',
            // 'basicSalary',
            'salary',
            'job_position',
            // 'product_code'
          ];
        } else {
          $ar = [
            'bank_id',
            'birthDate',
            'retirement_age',
            'hiringDate',
            'currentDate',
            // 'basicSalary',
            'salary',
            'job_position',
            // 'product_code'
          ];
        }
      } else {
        $ar = [
          'bank_id',
          'birthDate',
          // 'retirement_age',
          // 'hiringDate',
          'currentDate',
          'basicSalary',
          'salary',
          'job_position',
          // 'product_code'
        ];
      }
      const keysToCheck = $ar;
      const errors = [];

      Object.entries(payload).forEach(([key, value]) => {
        if (keysToCheck.includes(key)) {
          if (value === null || value === '' || value === undefined) {
            console.log(key, value);
            errors.push(this.getArabicErrorMessage(key));
          }

        }
      });

      return errors;
    },
    calculateAgeFromHijri(hijriDate) {
      if(! this.payload.birthDateMiladi && ! this.payload.birthDate) return;
      // check if  payload.date_type == 2 then calculate the age from the miladi date
      if (this.payload.date_type == 2) {
        const miladi = moment(this.payload.birthDateMiladi, 'YYYY-MM-DD');
        this.payload.age = moment().diff(miladi, 'years');
        console.log('this.payload.age from miladi date', this.payload.age);
      } else {
        const hijri = moment(hijriDate, 'iYYYY-iMM-iDD');
        this.payload.age = moment().diff(hijri, 'years');
        console.log('this.payload.age from hijri date', this.payload.age);
      }
    },
    // watch date_type
    "payload.date_type": {
      handler(val) {
        this.calculateAgeFromHijri(this.payload.birthDate);
      },
      deep: true
    }, 
    async fetchOptions() {
      const res2 = await Axios.get(
        'https://test-calc-app.alwsatarealestate.com/api/job-positions')
      this.jobs = res2.data.map(job => ({
        id: job.id,
        value: job.name_ar,
      }));
      const res3 = await Axios.get(
        'https://test-calc-app.alwsatarealestate.com/api/product-types')
      this.productTypes = res3.data.map(job => ({
        id: job.id,
        value: job.name_ar,
      }));
    },
    async fetchBanks() {
      const res = await Axios.get(
        'https://test-calc-app.alwsatarealestate.com/api/banks');
      this.banks = res.data.map(bank => ({
        id: bank.id,
        value: bank.name_ar,
        completed: !!bank.property_completed,
        incomplete: !!bank.property_uncompleted,
        joint: !!bank.joint,
        guarantees: !!bank.guarantees,
        check: !!bank.quest_check,
        vat: !!bank.bear_tax,
        sahal: !!bank.shl,
        active: !!bank.active,
      }));
    },
    calculate() {
      this.calc_error = this.checkEachField(this.payload);

      if (this.calc_error.length > 0) {
        console.log('errors', this.calc_error);
        // errors.forEach((value) => {
        //   console.log('errors', value);

        // });
        // this.showPopupError2("error", errors);
        return;
      }
      this.calculateAllBanks();
      this.btn_loading = true;
      let send_data = { ...this.payload };
      if(this.payload.date_type == 2){
        send_data.currentDate = this.payload.currentDateMiladi;
        send_data.hiringDate = this.payload.hiringDateMiladi;
        send_data.birthDate = this.payload.birthDateMiladi;
      }
      console.log("this.savedResultPayload2");
      Axios.post(
        `https://test-calc-app.alwsatarealestate.com/api/calculate`,
        send_data,
        { headers: this.request_headers() }
      )
        .then((res) => {
          this.result = res.data.result;
          this.savedResultPayload = {
            ded_pre: res.data.reusable.personal_salary_deduction,
            personal_salary_deduction: res.data.reusable.personal_salary_deduction,
            product_type: res.data.reusable.product_code,
            fundPersPre: res.data.reusable.personal_salary_installment,
            fundMonth: res.data.reusable.monthly_installment, //  القسط الشهري العقاري 
            fundDur: res.data.reusable.finance_months,
            realFun_pre: res.data.reusable.profit, // فائده التمويل العقاري
            funding_source: res.data.reusable.bank_id, // جهة التمويل
            fundReal: res.data.reusable.finance_amount, // مبلغ التمويل العقاري 
            installment_after_support: res.data.reusable.monthly_installment_after_support
          };
          console.log("this.savedResultPayload", this.savedResultPayload);
          this.newAgentData.funding.funding_duration = res.data.reusable.finance_months;
          this.newAgentData.funding.monthly_in = res.data.reusable.monthly_installment; //  القسط الشهري العقاري 
          this.newAgentData.funding.monthly_installment_after_support = res.data.reusable.monthly_installment_after_support; //  القسط الشهري العقاري 
          this.newAgentData.funding.personalFun_pre = res.data.reusable.before_retirment_deduction;
          this.newAgentData.funding.personal_monthly_installment = res.data.reusable.personal_salary_installment;
          this.newAgentData.funding.product_code = res.data.reusable.product_code;
          this.newAgentData.funding.ded_pre = res.data.reusable.personal_salary_deduction;
          this.newAgentData.funding.personal_salary_deduction = res.data.reusable.personal_salary_deduction;
          this.newAgentData.funding.realFun_pre = res.data.reusable.profit; // فائده التمويل العقاري
          this.newAgentData.funding.funding_source = res.data.reusable.bank_id; // جهة التمويل
          this.newAgentData.funding.realFun_cost = res.data.reusable.finance_amount; // مبلغ التمويل العقاري 
          this.newAgentData.funding.personalFun_cost = res.data.reusable.personal_finance_amount; // مبلغ التمويل العقاري 

          this.result_v2_steps = res.data.result_v2;
          this.expandedPanels = this.result_v2_steps.map((_, i) => i);
          /**/
          // installment_after_support: res.data.reusable.before_retirment_deduction
          // res.data.payload.result.forEach((bank) => {
          //   bank.show_programs = false;
          // });
          // this.fundResult = res.data.payload.result;
        })
        .catch((err) => {
          this.btn_loading = false;
          if (err.response?.data?.code == 402) {
            this.$refs.defaultSec.scrollIntoView({ behavior: 'smooth' });
          }
          console.log("err.response.data", err.response?.data?.code)
          // this.showPopup("error", err.response.data.message);
        })
        .finally(() => {
          this.btn_loading = false;
        });
      /*Axios.post(
        `${this.$store.state.url}/agent/Request/Funding/GoogleCalculator`,
        this.payload,
        { headers: this.request_headers() }
      )
        .then((res) => {
          res.data.payload.forEach((bank) => {
            bank.show_GH_programs = false;
          });
          let BankList = res.data.payload;
          this.GHResult = BankList;
        })
        .catch((err) => {
          this.showPopup("error", err.response.data.message);
        })
        .finally(() => {
          this.btn_loading = false;
        });*/
    },
    recalculate(bank_id) {
      this.payload.bank_id = bank_id;
      this.calculateAllBanks();
      this.btn_loading = true;
      let send_data = { ...this.payload };
      if(this.payload.date_type == 2){
        send_data.currentDate = this.payload.currentDateMiladi;
        send_data.hiringDate = this.payload.hiringDateMiladi;
        send_data.birthDate = this.payload.birthDateMiladi;
      }
      Axios.post(
        `https://test-calc-app.alwsatarealestate.com/api/calculate`,
        send_data,
        { headers: this.request_headers() }
      )
        .then((res) => {
          this.result = res.data.result;
          this.savedResultPayload = {
            product_type: res.data.reusable.product_code,
            fundPersPre: res.data.reusable.before_retirment_deduction,
            fundMonth: res.data.reusable.before_retirment_deduction, //  القسط الشهري العقاري 
            fundDur: res.data.reusable.finance_months,
            realFun_pre: res.data.reusable.profit, // فائده التمويل العقاري
            funding_source: res.data.reusable.bank_id, // جهة التمويل
            fundReal: res.data.reusable.finance_amount, // مبلغ التمويل العقاري 
            installment_after_support: res.data.reusable.before_retirment_deduction
          };
          console.log("this.savedResultPayload", this.savedResultPayload);
          this.result_v2_steps = res.data.result_v2;
          this.expandedPanels = this.result_v2_steps.map((_, i) => i);
          /**/
          // res.data.payload.result.forEach((bank) => {
          //   bank.show_programs = false;
          // });
          // this.fundResult = res.data.payload.result;
        })
        .catch((err) => {
          this.btn_loading = false;
          if (err.response?.data?.code == 402) {
            this.$refs.defaultSec.scrollIntoView({ behavior: 'smooth' });
          }
          this.showPopup("error", err.response.data.message);
        })
        .finally(() => {
          this.btn_loading = false;
        });
    },
    calculateAllBanks() {
      this.btn_loading = true;
      let send_data = { ...this.payload };
      if(this.payload.date_type == 2){
        send_data.currentDate = this.payload.currentDateMiladi;
        send_data.hiringDate = this.payload.hiringDateMiladi;
        send_data.birthDate = this.payload.birthDateMiladi;
      }
      Axios.post(
        `https://test-calc-app.alwsatarealestate.com/api/calculate-all-banks`,
        send_data,
        { headers: this.request_headers() }
      )
        .then((res) => {
          this.all_banks = res.data.result;
          // res.data.payload.result.forEach((bank) => {
          //   bank.show_programs = false;
          // });
          // this.fundResult = res.data.payload.result;
        })
        .catch((err) => {
          this.btn_loading = false;
          if (err.response?.data?.code == 402) {
            this.$refs.defaultSec.scrollIntoView({ behavior: 'smooth' });
          }
          // this.showPopup("error", err.response.data.message);
        })
        .finally(() => {
          this.btn_loading = false;
        });
      /*Axios.post(
        `${this.$store.state.url}/agent/Request/Funding/GoogleCalculator`,
        this.payload,
        { headers: this.request_headers() }
      )
        .then((res) => {
          res.data.payload.forEach((bank) => {
            bank.show_GH_programs = false;
          });
          let BankList = res.data.payload;
          this.GHResult = BankList;
        })
        .catch((err) => {
          this.showPopup("error", err.response.data.message);
        })
        .finally(() => {
          this.btn_loading = false;
        });*/
    },
    async calculateFactors() {
      this.calc_error = [];
      if (
        this.payload.birthDate &&
        this.payload.currentDate &&
        // this.payload.hiringDate &&
        this.payload.bank_id &&
        // this.payload.retirment_age &&
        this.payload.job_position &&
        this.payload.salary !== null &&
        this.payload.salary !== ''
      ) {
        this.loading = true;
        try {
          const res = await Axios.post('https://test-calc-app.alwsatarealestate.com/api/get-calculate-factors', this.payload);
          const rslt = res.data;
          this.showFactors = true;
          this.payload.after_retirment_deduction = res.data.after_retirment_deduction;
          this.payload.before_retirment_deduction = res.data.before_retirment_deduction;
          this.payload.profit = res.data.profit;
          this.payload.profit_personal = res.data.profit_personal;
          // this.payload.personal_deduction = res.data.personal_deduction;
          this.payload.age_limit = res.data.age_limit;
          /*
          savedResultPayload.product_code = res.data.product_id
          savedResultPayload.personalFun_pre = res.data.before_retirment_deduction
          savedResultPayload.monthly_in =  //  القسط الشهري العقاري 
          savedResultPayload.funding_duration
          savedResultPayload.realFun_pre = res.data.profit  // فائده التمويل العقاري
          savedResultPayload.funding_source // جهة التمويل
          savedResultPayload.realFun_cost // مبلغ التمويل العقاري 
          savedResultPayload.monthly_installment_after_support 
          */
          console.log("result", rslt);
        } catch (error) {
          console.error(error); // handle error properly
        } finally {
          this.loading = false;
        }
      }
    },
    showBankProgramms(index) {
      this.fundResult.forEach((bank) => (bank.show_programs = false));
      this.fundResult[index].show_programs = true;
    },
    showGHBankProgramms(index) {
      this.GHResult.forEach((bank) => (bank.show_GH_programs = false));
      this.GHResult[index].show_GH_programs = true;
    },
    numberWithCommas(num) {
      return num.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    },
    async saveResultDialog() {
      // this.save_result_dialog = true;
      this.btn_save_loading = true;
      this.saveResult();
      this.$store.state.calaculatorAgree = false;
      this.$store.state.calaculatorSaved = false;
    },
    async saveResult() {
      this.save_result_dialog = false;
      console.log("this.savedResultPayload", this.savedResultPayload);
      const saved_payload = { ...this.newAgentData, ...this.savedResultPayload }
      console.log("saved_payload", saved_payload);

      Axios.post(
        `${this.$store.state.url}/v2/employee/Requests-save-funding-data`,
        saved_payload,
        { headers: this.request_headers() }
      )
        .then((res) => {
          this.showPopup("success", res.data.message);
          this.$store.state.calaculatorNotFired = false;
          this.$emit("update:agent", saved_payload);
          this.$store.state.request_info = saved_payload;
          this.btn_save_loading = false;
        })
        .catch((err) => {
          if (err.response?.data?.code == 402) {
            this.$store.state.ValidationAsDialog = true;
            this.$store.state.ValidationAsDialogMessage = err.response.data.message;
            this.$store.state.arrayOfErrors = err.response.data.array;
          } else {
            if (Array.isArray(err.response.data.message)) {
              this.showPopupError("success", err.response.data.message);
            } else {
              this.showPopup("error", err.response.data.message);
            }
          }
          this.btn_save_loading = false;
        });
    },
    selectProgramm(bank, program, prorgam_name) {
      this.choose_loading = true;
      const payload = {
        program_name: prorgam_name == "flexibleProgram" ? "1x2 مرن" : "عقارى",
        request_id: this.$route.params.id,
        work: this.payload.work_source,
        military_rank: this.payload.military_rank,
        funding_source: this.payload.funding_source,
        birth_hijri: this.payload.birth_date_hijri,
        hiring_date: this.payload.hiring_date,
        has_obligations: this.payload.has_obligations,
        salary: program.salary,
        product_type_id: this.payload.product_code,
        bank_code: bank.bank_code,
        basic_salary: program.basic_salary,
        salary_bank_code: bank.bank_code,
        without_transfer_salary: program.is_salary_transfer ? 1 : 0,
        housing_allowance: program.housing_allowance,
        transfer_allowance: program.transfer_allowance,
        other_allowance: program.other_allowance,
        retirement_income: program.retirement_income,
        discount: program.discount,
        provide_first_batch: this.payload.provide_first_batch,
        first_batch_profit: program.first_batch_profit,
        first_batch_percentage: program.first_batch_percentage,
        fees: program.fees,
        job_tenure_months: program.job_tenure_months,
        personal_profit: program.personal_profit,
        profit: program.profit,
        net_loan_total: program.net_loan_total,
        personal_net_loan_total: program.personal_net_loan_total,
        personal_installment: program.personal_installment,
        installment: program.installment,
        installment_after_support: program.installment_after_support,
        credit_installment: program.credit_installment,
        obligations_installment: program.obligations_installment,
        remaining_obligations_months: program.remaining_obligations_months,
        property_amount: program.property_amount,
        residential_support: this.payload.residential_support,
        add_support_installment_to_salary:
          this.payload.add_support_installment_to_salary,
        guarantees: this.payload.guarantees,
        personal_salary_deduction: program.personal_salary_deduction,
        personal_funding_months: program.personal_funding_months,
        salary_deduction: program.salary_deduction,
        funding_months: program.funding_months,
        residence_type: program.residence_type,
        flexible_loan_total: program.flexible_loan_total,
        early_repayment: program.early_repayment,
        first_batch_mode: program.first_batch_mode,
        have_joint: this.payload.has_joint,
        joint_work: this.payload.joint_work,
        joint_military_rank: this.payload.joint_military_rank,
        joint_birth_hijri: this.payload.joint_birth_hijri,
        joint_salary: this.payload.joint_salary,
        joint_credit_installment: this.payload.joint_credit_installment,
        joint_remaining_obligations_months:
          this.payload.joint_remaining_obligations_months,
        joint_obligations_installment:
          this.payload.joint_obligations_installment,
        joint_early_repayment: this.payload.joint_early_repayment,
        joint_housing_allowance: this.payload.joint_housing_allowance,
        joint_transfer_allowance: this.payload.joint_transfer_allowance,
        joint_other_allowance: this.payload.joint_other_allowance,
        joint_retirement_income: this.payload.joint_retirement_income,
        joint_residential_support: this.payload.joint_residential_support,
        joint_add_support_installment_to_salary:
          this.payload.joint_add_support_installment_to_salary,
        joint_job_tenure: this.payload.joint_job_tenure,
        joint_job_tenure_months: this.payload.joint_job_tenure_months,
        joint_personal_salary_deduction:
          this.payload.joint_personal_salary_deduction,
        joint_personal_funding_months:
          this.payload.joint_personal_funding_months,
        joint_funding_months: this.payload.joint_funding_months,
        joint_salary_deduction: this.payload.joint_salary_deduction,
      };
      Axios.post(
        `${this.$store.state.url}/agent/Request/Funding/calculatorSelect`,
        payload,
        { headers: this.request_headers() }
      )
        .then(() => {
          this.showPopup("success", "تم اختيار نتيجة الحاسبة بنجاح");
          this.fundResult = [];
        })
        .catch((err) => {
          this.showPopup("error", err.response.data.message);
        })
        .finally(() => {
          this.choose_loading = false;
        });
    },
  },
};
</script>
<style scoped lang="scss">
.expands-div {
  background: #0f5b94;
  padding: 1px 15px;
  margin-top: 20px;
}

.v-item-group {
  .v-expansion-panel-header {
    background: #fff !important;
    min-height: unset !important;
    line-height: 0;
    font-weight: 700;
    color: #0f5b94;
    font-size: 17px;
    padding: 15px;
  }

  // .v-expansion-panel-content {
  //   /*background: #0f5b94;*/
  // }

  .prog-spans {
    display: flex;
    justify-content: flex-start;
    gap: 15px;
    flex-wrap: wrap;
    margin-top: 15px;

    span {
      color: #003d6b;
      font-weight: bold;
      font-size: 17px;
      background: #e1f2ff;
      padding: 13px;
      border-radius: 5px;
    }
  }
}

.selected-bank-div {
  background-color: #ead3eb;
  padding: 2px;
  border-radius: 4px;
}

.default-val-div {
  background: #fcf5ff;
  padding: 10px;
  border-right: 5px solid #451646 !important;
  border-radius: 15px;
}
</style>
<!-- 
product_code
personalFun_pre
monthly_in
funding_duration
realFun_pre
funding_source
realFun_cost
monthly_installment_after_support 

-->